import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface RestoreEngagementDocumentRequest {
    timelineId: number;
    documentId: string;
}

export const RestoreEngagementDocument = createAsyncThunk(
    'timeline/restoreEngagementDocument',
    async (
        { timelineId, documentId }: RestoreEngagementDocumentRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.put(
                `api/Marketplace/Engagements/${timelineId}/documents/${documentId}/restore`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not restore document at the moment.',
                    'error'
                );
                throw new Error('Failed to restore document');
            }

            return documentId;
        } catch (error) {
            createNotification(
                'An error occurred while restoring the document.',
                'error'
            );
            throw error;
        }
    }
);
